var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartBeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#a7f3d0",
    stroke: "#a7f3d0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.8 500.4h156.5l58.4-120.3 92.9 363.1L494.7 497h48.9l34 86.1 43.6-181.7 59.5 246.5 38.6-154.1h191.9s40.5-167.7-48.9-244.1c-107.7-92.1-204.5-56.6-298.3 38l-50.1 53.5-45.4-46.7S389.1 190 292.6 204.6c-89.1 13.5-205 120.5-148.8 295.8z",
    fill: "#047857F9C0C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m513.7 903.1-4.3-2.5c-.3-.2-39.2-22.4-95.8-63.6-52.2-37.9-130.6-100.3-208-181.8-35.2-37-62.3-75.9-80.7-115.5l13.6-6.3c17.7 38.1 43.9 75.7 77.9 111.5 134.9 142 274.5 227.4 297.2 240.8 22.9-13.6 162.5-99 297.2-240.8 36.7-38.7 64.3-79.2 81.9-120.5 15.8-36.8 23.7-74.3 23.5-111.3-.2-62.8-24.4-124.2-66.4-168.4-35.9-37.8-83.7-58.6-134.7-58.6s-98.9 20.8-134.7 58.6l-66.8 70.4-66.8-70.4c-35.9-37.8-83.7-58.6-134.7-58.6s-98.9 20.8-134.7 58.6c-25.5 26.8-44.8 60.4-55.8 97.1-12.7 42.3-14 86.3-3.9 131l-14.6 3.3c-10.7-47.2-9.3-93.8 4.2-138.6 11.7-39 32.2-74.6 59.3-103.1 38.7-40.8 90.4-63.2 145.6-63.2s106.9 22.5 145.6 63.2l55.9 58.9 55.9-58.9c38.7-40.8 90.4-63.2 145.6-63.2s106.9 22.5 145.6 63.2c44.5 46.9 70.2 112 70.5 178.6.1 39.1-8.2 78.6-24.7 117.3-18.4 42.9-46.9 84.9-84.9 124.9-77.4 81.5-155.9 143.9-208 181.8-56.6 41.2-95.5 63.4-95.9 63.6l-4.1 2.5z",
    fill: "#047857999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m454.1 769.3-96.6-377.4-54.7 116.5H76.6v-8h221.1l62.1-132.1 92.6 362L491.3 493h54.9l30.4 76.8 44.5-185.6 59.6 246.9 35.4-141.3h235v8H722.3l-41.8 166.8-59.4-246.2-42.6 177.9-37.7-95.3H498z",
    fill: "#047857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBeat);
export default __webpack_public_path__ + "static/media/Heart_Beat.2f92adf5cd7602172518366bda1db874.svg";
export { ForwardRef as ReactComponent };